import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { SocialNetworkProvider } from './share-buttons.models';

@Component({
  selector: 'planone-share-buttons',
  templateUrl: './share-buttons.component.html',
  styleUrls: ['./share-buttons.component.scss'],
})
export class ShareButtonsComponent implements OnInit, OnChanges {
  @Input()
  url: string | undefined = undefined;

  @Input()
  emailSubject = '';

  @Input()
  emailBody = '';

  @Input()
  disabledProvider: string[] | undefined;

  @Input() longText = false;

  @Output() shareButtonClicked: EventEmitter<string> = new EventEmitter<string>();

  copiedHint = $localize`:@@shareButtons-CopiedLink:Link wurde kopiert.`;

  providers: SocialNetworkProvider[] = [];

  ngOnInit(): void {
    this.setProviders(this.longText);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['longText']) {
      this.setProviders(changes['longText'].currentValue);
    }
  }

  action(provider: SocialNetworkProvider, tooltip: MatTooltip) {
    this.shareButtonClicked.emit(provider.sharebutton === 'twitter' ? 'x' : provider.sharebutton);

    if (provider.sharebutton === 'copy') {
      this.copy(tooltip);
    }
  }

  copy(tooltip: MatTooltip) {
    tooltip.show();

    setTimeout(() => {
      tooltip.hide();
    }, 2000);
  }

  trackByProvider = (_: number, item: { name: string; icon: string }) => item;

  private setProviders(long: boolean) {
    if (!long) {
      this.providers = [
        {
          name: $localize`:@@shareButtons-facebook-long:Facebook`,
          icon: 'social-facebook',
          sharebutton: 'facebook',
        },
        {
          name: $localize`:@@shareButtons-linkedin-long:LinkedIn`,
          icon: 'social-linkedin',
          sharebutton: 'linkedin',
        },
        {
          name: $localize`:@@shareButtons-xing-long:Xing`,
          icon: 'social-xing',
          sharebutton: 'xing',
        },
        {
          name: $localize`:@@shareButtons-x-long:X`,
          icon: 'social-x',
          sharebutton: 'twitter',
        },
        {
          name: $localize`:@@shareButtons-pinterest-long:Pinterest`,
          icon: 'social-pinterest',
          sharebutton: 'pinterest',
        },
        {
          name: $localize`:@@shareButtons-email-long:E-Mail`,
          icon: 'mail',
          sharebutton: 'email',
        },
        {
          name: $localize`:@@shareButtons-print-long:Drucken`,
          icon: 'print',
          sharebutton: 'print',
        },
        {
          name: $localize`:@@shareButtons-copyLink-long:Link kopieren`,
          icon: 'copy',
          sharebutton: 'copy',
        },
      ];
    } else {
      this.providers = [
        {
          name: $localize`:@@shareButtons-facebook:Facebook`,
          icon: 'social-facebook',
          sharebutton: 'facebook',
        },
        {
          name: $localize`:@@shareButtons-linkedin:LinkedIn`,
          icon: 'social-linkedin',
          sharebutton: 'linkedin',
        },
        {
          name: $localize`:@@shareButtons-xing:Xing`,
          icon: 'social-xing',
          sharebutton: 'xing',
        },
        {
          name: $localize`:@@shareButtons-x:X`,
          icon: 'social-x',
          sharebutton: 'twitter',
        },
        {
          name: $localize`:@@shareButtons-pinterest:Pinterest`,
          icon: 'social-pinterest',
          sharebutton: 'pinterest',
        },
        {
          name: $localize`:@@shareButtons-email:Per Email senden`,
          icon: 'mail',
          sharebutton: 'email',
        },
        {
          name: $localize`:@@shareButtons-print:Drucken`,
          icon: 'print',
          sharebutton: 'print',
        },
        {
          name: $localize`:@@shareButtons-copyLink:Link kopieren`,
          icon: 'copy',
          sharebutton: 'copy',
        },
      ];
    }
  }
}
